var indexOf = [].indexOf;

angular.module('gym.calendar').factory('MonthlyOccurrenceOptionsService', ["$filter", function($filter) {
  var generateRecurrenceOptions;
  generateRecurrenceOptions = function(entity, eventType) {
    var copyText, dayOfMonth, dayOfWeekIndex, dayOfWeekName, lastPossibleDay, lastWdayOption, lastWeekStart, nthWdayOption, optionValues, options, prevSelection, selectedDate, weekOccurrence;
    if (!(entity != null ? entity.start_date : void 0)) {
      return;
    }
    selectedDate = moment(entity.start_date);
    dayOfMonth = selectedDate.date();
    copyText = eventType != null ? eventType : 'event';
    dayOfWeekIndex = selectedDate.day();
    dayOfWeekName = selectedDate.format('dddd');
    weekOccurrence = Math.ceil(dayOfMonth / 7);
    lastPossibleDay = moment(selectedDate).endOf('month').date();
    lastWeekStart = lastPossibleDay - 6;
    options = [
      {
        value: 'repeat_on_nth_day_of_month',
        label: `the ${$filter('ordinal')(dayOfMonth)} day of the month`
      }
    ];
    nthWdayOption = null;
    lastWdayOption = null;
    if (weekOccurrence === 1 || weekOccurrence === 2 || weekOccurrence === 3 || weekOccurrence === 4) {
      nthWdayOption = {
        value: 'repeat_on_nth_wday_of_month',
        label: `the ${$filter('ordinal')(weekOccurrence)} ${dayOfWeekName} of the month`
      };
      options.push(nthWdayOption);
    }
    if (dayOfMonth >= lastWeekStart) {
      lastWdayOption = {
        value: 'repeat_on_last_wday_of_month',
        label: `the last ${dayOfWeekName} of the month`
      };
      options.push(lastWdayOption);
    }
    prevSelection = entity.selectedRepeatOption;
    optionValues = options.map(function(opt) {
      return opt.value;
    });
    if (prevSelection === 'repeat_on_nth_wday_of_month' && !nthWdayOption) {
      entity.selectedRepeatOption = 'repeat_on_last_wday_of_month';
    } else if (prevSelection === 'repeat_on_last_wday_of_month' && !lastWdayOption) {
      entity.selectedRepeatOption = 'repeat_on_nth_wday_of_month';
    } else if (indexOf.call(optionValues, prevSelection) >= 0) {
      entity.selectedRepeatOption = prevSelection;
    } else {
      entity.selectedRepeatOption = options[0].value;
    }
    switch (entity.selectedRepeatOption) {
      case 'repeat_on_nth_day_of_month':
        entity.monthly_repeat_rule = 'repeat_on_nth_day_of_month';
        entity.monthly_repeat_wday = null;
        entity.monthly_repeat_wday_count = null;
        break;
      case 'repeat_on_nth_wday_of_month':
        entity.monthly_repeat_rule = 'repeat_on_nth_wday_of_month';
        entity.monthly_repeat_wday = dayOfWeekIndex;
        entity.monthly_repeat_wday_count = weekOccurrence;
        break;
      case 'repeat_on_last_wday_of_month':
        entity.monthly_repeat_rule = 'repeat_on_last_wday_of_month';
        entity.monthly_repeat_wday = dayOfWeekIndex;
        entity.monthly_repeat_wday_count = null;
    }
    return {
      options: options,
      hint: entity.selectedRepeatOption === 'repeat_on_nth_day_of_month' && dayOfMonth >= 29 ? `When month contains fewer than ${dayOfMonth} days, ${copyText} will be scheduled on the last day of the month.` : ""
    };
  };
  return {
    generateRecurrenceOptions: generateRecurrenceOptions
  };
}]);
